// @ts-nocheck

import { Licences } from '../types/common';

export const defaultLicence = global.$siteLicense || (global.getAppLicence && global.getAppLicence()) || Licences.FR;
